import { Pagination, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AutostoreTable } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "~/app/store";

import { IncompleteCycleCountResponseDto } from "~/types/api";

import { CycleCountsTableProps } from "./CycleCountsTableWrapper";
import { setPage } from "./cycleCountsNew.slice";

const CycleCountsTable = ({
  cycleCountData,
  cycleCountVariantData,
  selectedRows,
  isLoadingData,
  setSelectedRows,
  totalPageCount,
  page
}: CycleCountsTableProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  return (
    <>
      <AutostoreTable<IncompleteCycleCountResponseDto>
        headerColNames={[t("product"), t("bin count"), t("due by")]}
        rowId={(row: IncompleteCycleCountResponseDto) => row.cycleCountId}
        renderColumns={[
          (row) => {
            const product =
              cycleCountVariantData && Array.isArray(cycleCountVariantData)
                ? cycleCountVariantData.find(
                    (cycleCount) => cycleCount.variantId === row.variantId
                  )
                : undefined;
            return (
              <div>
                <Typography variant="body2">{product?.productName}</Typography>
              </div>
            );
          },
          (row: IncompleteCycleCountResponseDto) => {
            return (
              <div>
                <Typography variant="body2">
                  {row.countingTasks.length}
                </Typography>
              </div>
            );
          },
          (row: IncompleteCycleCountResponseDto) => {
            return (
              <div>
                <Typography variant="body2">{row.dueDate}</Typography>
              </div>
            );
          }
        ]}
        widthOfCols={["40%", "20%", "20%", "20%"]}
        headerVariant="overline"
        bodyVariant="body2"
        rowData={cycleCountData.cycleCounts}
        selectedRows={selectedRows.map((row) => row.cycleCountId)}
        selectRowCallback={(row: IncompleteCycleCountResponseDto) => {
          if (
            selectedRows.some(
              (selectedRow) => selectedRow.cycleCountId === row.cycleCountId
            )
          ) {
            setSelectedRows(
              selectedRows.filter(
                (selectedRow) => selectedRow.cycleCountId !== row.cycleCountId
              )
            );
          } else {
            setSelectedRows([
              ...selectedRows,
              {
                cycleCountId: row.cycleCountId,
                variantId: row.variantId,
                binCount: row.countingTasks.length
              }
            ]);
          }
        }}
        loading={isLoadingData}
      />

      <Box
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        {totalPageCount > 1 && (
          <Pagination
            count={totalPageCount}
            page={page}
            onChange={(_e, p) => {
              dispatch(setPage(p));
              if (window.scrollTo) window.scrollTo(0, 0);
            }}
            shape="rounded"
          />
        )}
      </Box>
    </>
  );
};

export default CycleCountsTable;
